export default __webpack_public_path__ + "static/media/ticket-booking-app-circle.1cf19eff.webp";